"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYSIS_PALETTE = void 0;
/**
 * Colours of the video/article analysis surfaces, as the website renders them
 * below its 768px breakpoint. The analysis keeps its own family; it is not the
 * home-v2 navy ink ramp used by the feed.
 */
exports.ANALYSIS_PALETTE = {
    surfaceDark: '#000000',
    textOnDark: '#F0F0F0',
    band: '#0A2342',
    skimBand: 'rgba(0, 102, 204, 0.3)',
    articleHeaderBand: '#081C45',
    accent: '#2979FF',
    accentActive: '#FF6B6B',
    progress: '#005BB5',
    track: '#C0C0C0',
    ink: '#001F3D',
    inkNeutral: '#1E1E1E',
    inkMuted: '#757575',
    chipBg: '#E6ECFF',
    chipInk: '#1E3A8A',
    surface: '#FDFDFD',
    surfaceAlt: '#F5F7FA',
    reasonBg: '#F0F6FF',
    biasReasonBg: '#E6EEFF',
    biasReasonBorder: '#5F8DEE',
    chartTrack: '#333333',
    miniChartTrack: '#CDD9FF',
    timelineTrack: '#333333',
    tierToggleBg: 'rgba(255, 255, 255, 0.1)',
    segment: {
        high: '#2563EB',
        default: '#3B82F6',
        low: '#60A5FA',
    },
    /**
     * Timeline segment shades, handed out in time order. Each step jumps
     * between a darker and a lighter blue, so segments that touch never read as
     * one bar (the closest pair, including the wrap back to the first shade, is
     * 1.8:1 apart where `segment` sat at 1.4:1).
     */
    segmentCycle: ['#3B82F6', '#1D4ED8', '#60A5FA', '#2563EB', '#93C5FD'],
    snippet: {
        facts: { tint: '#D8FFF2', border: '#00B378', reasonTint: '#D8FFF2' },
        opinions: { tint: '#FFFAE0', border: '#FFD700', reasonTint: '#FFFAE0' },
        claims: { tint: '#FFE6DE', border: '#EA420F', reasonTint: '#FEEBE5' },
    },
    chart: {
        facts: '#00B378',
        opinions: '#FFD700',
        claims: '#EA420F',
    },
    stance: {
        for: '#008000',
        against: '#DC2626',
        neutral: '#383838',
    },
    conflictChip: '#3E67A8',
    sourceChip: '#0A2342',
    neutralMetric: '#CBD5E1',
    neutralMetricTint: '#E2E8F0',
};
